const allProfileStatus = ['Ready to work', 'Part time', 'Busy'];

export default allProfileStatus;
